const baseUrl = () => {
   //  return 'https://staging2.lalpathlabs.com/npsapi/api';
    // return 'https://webapi.lalpathlabs.com/npsapi/api';
    return 'https://webapi.lalpathlabs.com/npsapi_pre/api';
};

export default baseUrl;